<template>
	<PopupRouterViewDetail label="Part Good Receipt Detail" @hideMethod="onHidden" :isShowCopyData="false">

		<!-- APP_DETAIL_HEADER -->
		
		<b-card header="Part Good Receipt" class="mb-3">
			<b-row>
				<b-col cols="12" lg="6">
					<app-input-combobox-autocomplete :options="purchaseOrders" optionsLabel="purchaseOrderNumber"
						optionsKey="id" label-cols-lg="12" label="Purchase Order" id="fieldset-purchase-order" size="sm"
						:model.sync="model.purchaseOrderId" :isRequired="true" :state="validateState('purchaseOrderId')"
						:errorMessage="getErrorMessage(errorMessage.purchaseOrderId, 'purchaseOrderId')"
						:selected="model.purchaseOrder != null ? model.purchaseOrder.purchaseOrderNumber : ''"
						@input="getPurchaseOrders" @change="updateData" :isEditable="false" :isSelectMethodExists="true"
						@onSelectMethod="setSelectedPurchaseOrder" />
					<app-label label-cols-lg="12" size="sm" type="generatednumber" label="GR Number"
						:model="model.partGoodReceiptNumber" />
					<app-input-datepicker id="fieldset-part-good-receipt-date" label-cols-lg="12"
						label="GR Date" size="sm" :model.sync="model.partGoodReceiptDate" :isRequired="true"
						:state="validateState('partGoodReceiptDate')"
						:errorMessage="getErrorMessage(errorMessage.partGoodReceiptDate, 'partGoodReceiptDate')"
						:date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB"
						@change="updateData" :isEditable="false" />
				</b-col>
				<b-col cols="12" lg="6">
					<app-input-textbox id="fieldset-surat-jalan" label-cols-lg="12" label="Surat Jalan"
						label-for="input-surat-jalan" size="sm" :model.sync="model.suratJalan" :isRequired="true"
						:state="validateState('suratJalan')"
						:errorMessage="getErrorMessage(errorMessage.suratJalan, 'suratJalan')" @change="updateData"
						:isEditable="false" />
					<app-input-textarea id="fieldset-remark" label-cols-lg="12" label="Remark" label-for="input-remark"
						size="sm" :model.sync="model.remark" @change="updateData" :isEditable="false" />
				</b-col>

			</b-row>
		</b-card>
		<app-table-input-custom title="Part Good Receipt Case" :bordered="true" :items="partGoodReceiptCases"
			:fields="fieldsPartGoodReceiptCase" :busy="isDataLoading" :sort-by.sync="sortByPartGoodReceiptCase"
			:sort-desc.sync="sortDescPartGoodReceiptCase" small responsive
			@editButtonMethod="editRowDataPartGoodReceiptCase" @deleteButtonMethod="deleteRowDataPartGoodReceiptCase"
			@showPopupAddMethod="resetDataPartGoodReceiptCase()"
			@showPopupUploadMethod="showPopupUploadPartGoodReceiptCase()"
			@downloadMethod="downloadPartGoodReceiptCase()"
			@addFromClipboardMethod="addFromClipboardPartGoodReceiptCase()"
			@replaceFromClipboardMethod="replaceFromClipboardPartGoodReceiptCase()" :showActionButton="true"
			:showEditButton="false" :showDeleteButton="false" :showAddButton="false" :showAddFromClipboardButton="false"
			:showReplaceFromClipboardButton="false" :showUploadButton="false" :showDownloadButton="false"
			:isDownloadBusy="isDownloadPartGoodReceiptCase">
			<template #top-row v-if="isShowPartGoodReceiptCaseFilter">
				<b-th></b-th>
				<b-th></b-th>
				<b-th stacked-heading="Purchase Order Detail">
					<v-select append-to-body label="qtyPo" :options="purchaseOrderDetails"
						:value="filterPartGoodReceiptCase.purchaseOrderDetailId" :reduce="item => item.id"
						v-model="filterPartGoodReceiptCase.purchaseOrderDetailId" @search="getPurchaseOrderDetails"
						:filterable="true"></v-select>
				</b-th>
				<b-th stacked-heading="Part">
					<v-select append-to-body label="partNumber" :options="parts"
						:value="filterPartGoodReceiptCase.partId" :reduce="item => item.id"
						v-model="filterPartGoodReceiptCase.partId" @search="getParts" :filterable="true"></v-select>
				</b-th>
				<b-th stacked-heading="Supplier Case Number">
					<b-form-input id="input-supplier-case-number-table"
						v-model="filterPartGoodReceiptCase.supplierCaseNumber" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Control Card">
					<v-select append-to-body label="controlCardNumber" :options="controlCards"
						:value="filterPartGoodReceiptCase.controlCardId" :reduce="item => item.id"
						v-model="filterPartGoodReceiptCase.controlCardId" @search="getControlCards"
						:filterable="true"></v-select>
				</b-th>
				<b-th stacked-heading="Qty Inventory">
					<b-form-input id="input-qty-inventory-table" v-model="filterPartGoodReceiptCase.qtyActual"
					size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Qty Po">
					<b-form-input id="input-qty-po-table" v-model="filterPartGoodReceiptCase.qtyPo"
						size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Remark">
					<b-form-input id="input-remark-table" v-model="filterPartGoodReceiptCase.remark"
						size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Part Good Receipt Detail">
					<v-select append-to-body label="part" :options="partGoodReceiptDetails"
						:value="filterPartGoodReceiptCase.partGoodReceiptDetailId" :reduce="item => item.id"
						v-model="filterPartGoodReceiptCase.partGoodReceiptDetailId" @search="getPartGoodReceiptDetails"
						:filterable="true"></v-select>
				</b-th>

				<b-th></b-th>
			</template>
			<template v-slot:cell(front-action)="row">
				<b-overlay :show="isBusy" rounded opacity="0.6" spinner-small spinner-variant="primary"
					class="float-right mr-2">
						<b-button class="btn-outline-success" size="sm" @click="printMcc(row.item)">
							<b-icon-printer class="mr-1" />Print MCC</b-button>
					</b-overlay>
			</template>
			<template v-slot:cell(no)="row">
				{{ ((row.index + 1) + (partGoodReceiptCasePageSize * (currentPartGoodReceiptCasePage - 1))) }}
			</template>
			<template v-slot:table-busys>
				<div class="text-center my-2">
					<b-spinner class="align-middle text-primary"></b-spinner>
					<strong class="ml-2">Loading...</strong>
				</div>
			</template>
			<template v-slot:cell(purchaseOrderDetail)="row">
				<app-input-combobox-autocomplete :options="purchaseOrderDetails" optionsLabel="purchaseOrderNumber" optionsKey="id"
					:id="'input-part-good-receipt-case-purchase-order-detail-' + row.index" label-cols-lg="12"
					label="Purchase Order Detail" size="sm" :model.sync="row.item.purchaseOrderDetailId"
					@change="saveInputPartGoodReceiptCase(row.item)"
					:selected="row.item.purchaseOrderDetail != null ? row.item.purchaseOrderDetail.qtyPo : ''"
					@input="getPurchaseOrderDetails" :loading="isPurchaseOrderDetailComboLoading" :isUpdatable="true"
					:nolabel="true" />
			</template>
			<template v-slot:cell(part)="row">
				<app-input-combobox-autocomplete :options="parts" optionsLabel="partNameCombination" optionsKey="id"
					:id="'input-part-good-receipt-case-part-' + row.index" label-cols-lg="12" label="Part" size="sm"
					:model.sync="row.item.partId" :state="validateState('partId')"
					:errorMessage="getErrorMessage(errorMessage.partId, 'partId')"
					@change="saveInputPartGoodReceiptCase(row.item)" :selected="getPartNumSpec(row.item.part)"
					@input="getParts" :loading="isPartComboLoading" :isEditable="false" :nolabel="true" />
			</template>
			<template v-slot:cell(supplierCaseNumber)="row">
				<app-input-textbox :id="'input-part-good-receipt-case-supplier-case-number-' + row.index"
					label-cols-lg="12" label="Supplier Case Number" size="sm" :model.sync="row.item.supplierCaseNumber"
					:state="validateState('supplierCaseNumber')"
					:errorMessage="getErrorMessage(errorMessage.supplierCaseNumber, 'supplierCaseNumber')"
					@change="saveInputPartGoodReceiptCase(row.item)" :isEditable="false" :nolabel="true" />
			</template>
			<template v-slot:cell(controlCard)="row">
				<app-input-combobox-autocomplete :options="controlCards" optionsLabel="controlCardNumber"
					optionsKey="id" :id="'input-part-good-receipt-case-control-card-' + row.index" label-cols-lg="12"
					label="Control Card" size="sm" :model.sync="row.item.controlCardId"
					@change="saveInputPartGoodReceiptCase(row.item)"
					:selected="row.item.controlCard != null ? row.item.controlCard.controlCardNumber : ''"
					@input="getControlCards" :loading="isControlCardComboLoading" :isEditable="false" :nolabel="true" />
			</template>
			<!-- <template v-slot:cell(qtyReceive)="row">
				<app-input-textbox :id="'input-part-good-receipt-case-qty-receive-' + row.index" label-cols-lg="12"
					label="Qty Receive" size="sm" :model.sync="row.item.qtyReceive" :state="validateState('qtyReceive')"
					:errorMessage="getErrorMessage(errorMessage.qtyReceive, 'qtyReceive')" type="number"
					@change="saveInputPartGoodReceiptCase(row.item)" :isEditable="isLastGR" :isUpdatable="isLastGR"
					:nolabel="true" /> -->
			<template v-slot:cell(qtyActual)="row">
				<app-input-textbox-custom :id="'input-part-good-receipt-case-qty-inventory-' + row.index" label-cols-lg="12"
					label="Qty Inventory" size="sm" :model.sync="row.item.qtyActual" :decimalSeparator="true"
					@change="saveInputPartGoodReceiptCase(row.item)" :isEditable="checkLastGR(row.item)"
					:nolabel="true" />
			</template>
			<template v-slot:cell(qtyPo)="row">
				<app-input-textbox-custom :id="'input-part-good-receipt-case-qty-po-' + row.index" label-cols-lg="12"
					label="Qty Po" size="sm" :model.sync="row.item.qtyPo" :decimalSeparator="true"
					@change="saveInputPartGoodReceiptCase(row.item)" :isEditable="checkLastGR(row.item)"
					:nolabel="true" />
			</template>
			<template v-slot:cell(remark)="row">
				<app-input-textarea :id="'input-part-good-receipt-case-remark-' + row.index" label-cols-lg="12"
					label="Remark" size="sm" :model.sync="row.item.remark"
					@change="saveInputPartGoodReceiptCase(row.item)" :isEditable="true" :nolabel="true" />
			</template>
			<template v-slot:cell(partGoodReceiptDetail)="row">
				<app-input-combobox-autocomplete :options="partGoodReceiptDetails" optionsLabel="part" optionsKey="id"
					:id="'input-part-good-receipt-case-part-good-receipt-detail-' + row.index" label-cols-lg="12"
					label="Part Good Receipt Detail" size="sm" :model.sync="row.item.partGoodReceiptDetailId"
					@change="saveInputPartGoodReceiptCase(row.item)"
					:selected="row.item.partGoodReceiptDetail != null ? row.item.partGoodReceiptDetail.part : ''"
					@input="getPartGoodReceiptDetails" :loading="isPartGoodReceiptDetailComboLoading"
					:isUpdatable="true" :nolabel="true" />
			</template>

			<template v-slot:form-add-detail>
				<PartGoodReceiptCaseInput :openPopup="isShowPopupPartGoodReceiptCase" :modelId="partGoodReceiptCaseId"
					@resetMethod="resetModal" @addButtonMethod="addRowDataPartGoodReceiptCase" />
			</template>
			<template v-slot:upload-detail>
				<PartGoodReceiptCaseUpload :openPopup="isShowPopupUploadPartGoodReceiptCase" @resetMethod="resetModal"
					@uploadButtonMethod="uploadDataPartGoodReceiptCase" :parentId="modelId" />
			</template>
			<template #row-details="row">
				<b-card>
					<app-input-combobox-autocomplete :options="parts" optionsLabel="partNumber" optionsKey="id"
						:id="'input-part-good-receipt-case-part-' + row.index" label-cols-lg="12" label="Part" size="sm"
						:model.sync="row.item.partId" :state="validateState('partId')"
						:errorMessage="getErrorMessage(errorMessage.partId, 'partId')"
						@change="saveInputPartGoodReceiptCase(row.item)"
						:selected="row.item.part != null ? row.item.part.partNumber : ''" @input="getParts"
						:loading="isPartComboLoading" :isUpdatable="false" :isEditable="false" />
					<app-input-textbox :id="'input-part-good-receipt-case-supplier-case-number-' + row.index"
						label-cols-lg="12" label="Supplier Case Number" size="sm"
						:model.sync="row.item.supplierCaseNumber" :state="validateState('supplierCaseNumber')"
						:errorMessage="getErrorMessage(errorMessage.supplierCaseNumber, 'supplierCaseNumber')"
						@change="saveInputPartGoodReceiptCase(row.item)" :isUpdatable="false" :isEditable="false" />
					<app-input-combobox-autocomplete :options="controlCards" optionsLabel="controlCardNumber"
						optionsKey="id" :id="'input-part-good-receipt-case-control-card-' + row.index"
						label-cols-lg="12" label="Control Card" size="sm" :model.sync="row.item.controlCardId"
						@change="saveInputPartGoodReceiptCase(row.item)"
						:selected="row.item.controlCard != null ? row.item.controlCard.controlCardNumber : ''"
						@input="getControlCards" :loading="isControlCardComboLoading" :isUpdatable="false"
						:isEditable="false" />
					<app-input-textbox-custom :id="'input-part-good-receipt-case-qty-inventory-' + row.index" label-cols-lg="12"
						label="Qty Inventory" size="sm" :model.sync="row.item.qtyActual" :decimalSeparator="true"
						@change="saveInputPartGoodReceiptCase(row.item)" :isEditable="checkLastGR(row.item)"
						:nolabel="true" />
					<app-input-textbox-custom :id="'input-part-good-receipt-case-qty-po-' + row.index" label-cols-lg="12"
						label="Qty Po" size="sm" :model.sync="row.item.qtyPo" :decimalSeparator="true"
						@change="saveInputPartGoodReceiptCase(row.item)" :isEditable="checkLastGR(row.item)"
						:nolabel="true" />
					<!-- <app-input-textbox :id="'input-part-good-receipt-case-qty-receive-' + row.index" label-cols-lg="12"
						label="Qty Receive" size="sm" :model.sync="row.item.qtyReceive" :state="validateState('qtyReceive')"
						:errorMessage="getErrorMessage(errorMessage.qtyReceive, 'qtyReceive')"
						@change="saveInputPartGoodReceiptCase(row.item)" :isUpdatable="false" :isEditable="false" /> -->
					<app-input-textarea :id="'input-part-good-receipt-case-remark-' + row.index" label-cols-lg="12"
						label="Remark" size="sm" :model.sync="row.item.remark"
						@change="saveInputPartGoodReceiptCase(row.item)" :isEditable="true" :nolabel="true" />
				</b-card>
			</template>

		</app-table-input-custom>
		<!-- END_APP_DETAIL_HEADER -->
		<PopupPDF :openPopup="isShowPopupPDF" :pdfUrl="pdfUrl" @resetModalMethod="resetModal"
			label="Print Good Receipt" />

		<template #modal-left-button>
			<b-overlay :show="isBusy" rounded opacity="0.6" spinner-small spinner-variant="primary"
					class="float-right mr-2">
				<b-button size="sm" class="float-right btn-outline-success" @click="printPdf"><b-icon-printer class="mr-1" /> Print GR Document</b-button>
				<b-button size="sm" class="float-right btn-outline-success mr-1" @click="printMccBatch"><b-icon-printer class="mr-1" /> Print Mcc</b-button>
			</b-overlay>
		</template>
		<b-overlay :show="isBusy" no-wrap>
		</b-overlay>
	</PopupRouterViewDetail>
</template>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import PartGoodReceipt from '@/models/PartGoodReceipt/PartGoodReceipt';
import PartGoodReceiptList from '@/models/PartGoodReceipt/PartGoodReceiptList';
import PartGoodReceiptFilter from '@/filters/PartGoodReceipt/PartGoodReceiptFilter';

import PopupRouterViewDetail from '@/components/PopupRouterViewDetail';

import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import PurchaseOrder from '@/models/PurchaseOrder/PurchaseOrder';
import PurchaseOrderFilter from '@/filters/PurchaseOrder/PurchaseOrderFilter';
import AppLabel from '@/components/AppLabel';
import AppInputDatepicker from '@/components/AppInputDatepicker';
import AppInputDatepickerRange from '@/components/AppInputDatepickerRange';
import AppInputTextbox from '@/components/AppInputTextbox';
import AppInputTextboxCustom from '@/components/AppInputTextboxCustom';
import AppInputTextarea from '@/components/AppInputTextarea';
import PartGoodReceiptDetail from '@/models/PartGoodReceipt/PartGoodReceiptDetail';
import PartGoodReceiptDetailFilter from '@/filters/PartGoodReceipt/PartGoodReceiptDetailFilter';
import PartGoodReceiptCase from '@/models/PartGoodReceipt/PartGoodReceiptCase';
import PartGoodReceiptCaseFilter from '@/filters/PartGoodReceipt/PartGoodReceiptCaseFilter';
import PurchaseOrderDetail from '@/models/PurchaseOrder/PurchaseOrderDetail';
import PurchaseOrderDetailFilter from '@/filters/PurchaseOrder/PurchaseOrderDetailFilter';
import Part from '@/models/Part/Part';
import PartFilter from '@/filters/Part/PartFilter';
import AppTableInputCustom from '@/components/AppTableInputCustom';
import AppTableInput from '@/components/AppTableInput';
import AppTableInputPopup from '@/components/AppTableInputPopup';
import PartGoodReceiptDetailInput from '@/views/PartGoodReceipt/PartGoodReceiptDetailInput';
import PartGoodReceiptDetailUpload from '@/views/PartGoodReceipt/PartGoodReceiptDetailUpload';
import ControlCard from '@/models/ControlCard/ControlCard';
import ControlCardFilter from '@/filters/ControlCard/ControlCardFilter';
import PartGoodReceiptCaseInput from '@/views/PartGoodReceipt/PartGoodReceiptCaseInput';
import PartGoodReceiptCaseUpload from '@/views/PartGoodReceipt/PartGoodReceiptCaseUpload';
import PopupRouterView from '@/components/PopupRouterView';
import PopupPDF from '@/components/PopupPDF';

export default {
	components: {
		AppInputComboboxAutocomplete,
		AppLabel,
		AppInputDatepicker,
		AppInputDatepickerRange,
		AppInputTextbox,
		AppInputTextarea,
		PartGoodReceiptDetailInput, PartGoodReceiptDetailUpload,
		PartGoodReceiptCaseInput, PartGoodReceiptCaseUpload,
		AppTableInput,
		AppTableInputCustom,
		AppTableInputPopup,
		PopupRouterViewDetail,
		PopupRouterView,
		PopupPDF,
		AppInputTextboxCustom,
	},
	mixins: [validationMixin],
	validations: {
		model: {
			purchaseOrderId: { required },
			partGoodReceiptDate: { required },
			suratJalan: { required },
		},
	},
	data() {
		return {
			errorMessage: {
				purchaseOrderId: { required: "Purchase Order is Required." },
				partGoodReceiptDate: { required: "PartGoodReceiptDate is Required." },
				suratJalan: { required: "Surat Jalan is Required." },
			},
			datas: Array(),
			selectAll: false,
			sortBy: '',
			sortDesc: '',
			pagingOptions: [
				{ value: '10', text: '10', selected: true },
				{ value: '25', text: '25' },
				{ value: '50', text: '50' },
				{ value: '100', text: '100' },
			],
			fieldsPartGoodReceiptDetail: [
				{ "frontActions": { "class": "th-actions", "label": "" } },
				{ "no": { "class": "th-number d-stack-none" } },
				{ "part": { "class": "th-part first-child", "label": "Part Code", key: 'part', sortable: false } },
				{ "poQtyOutstanding": { "class": "th-po-qty-outstanding", "label": "PoQtyOutstanding", key: 'poQtyOutstanding', sortable: false } },
				{ "qtyReceived": { "class": "th-qty-received last-child", "label": "QtyReceived", key: 'qtyReceived', sortable: false } },
				{ "remark": { "class": "th-remark d-stack-none", "label": "Remark", key: 'remark', sortable: false } },
				{ "actions": { "class": "th-actions d-stack-show", "label": "" } }
			],
			fieldsPartGoodReceiptCase: [
				{ "front-action": { "class": "th-front-action", "label": "" } },
				{ "no": { "class": "th-number d-stack-none" } },
				{ "part": { "class": "th-part first-child", "label": "Part", key: 'part', sortable: false } },
				{ "supplierCaseNumber": { "class": "th-supplier-case-number", "label": "Supplier Case Number", key: 'supplierCaseNumber', sortable: false } },
				{ "controlCard": { "class": "th-control-card last-child", "label": "Control Card", key: 'controlCard', sortable: false } },
				{ "qtyActual": { "class": "th-qty-inventory d-stack-none", "label": "Qty Inventory", key: 'qtyActual', sortable: false } },
				{ "qtyPo": { "class": "th-qty-po d-stack-none", "label": "Qty Po", key: 'qtyPo', sortable: false } },
				{ "remark": { "class": "th-remark d-stack-none", "label": "Remark", key: 'remark', sortable: false } },
				{ "actions": { "class": "th-actions d-stack-show", "label": "" } }
			],
			busy: false,
			isBusy: false,
			isDataLoading: false,
			selected: '',
			pageSizeOptions: 10,
			pageIndex: 0,
			sortingBy: Array(),
			modelId: null,
			model: {},
			modelPartGoodReceiptDetail: {},
			isShowPopupPartGoodReceiptDetail: false,
			isShowPopupUploadPartGoodReceiptDetail: false,
			modelPartGoodReceiptCase: {},
			isShowPopupPartGoodReceiptCase: false,
			isShowPopupUploadPartGoodReceiptCase: false,
			filterPartGoodReceipt: null,
			currentPartGoodReceiptPage: 1,
			partGoodReceiptPageSize: 10,
			sortByPartGoodReceipt: '',
			sortDescPartGoodReceipt: '',
			filterPartGoodReceiptDetail: null,
			currentPartGoodReceiptDetailPage: 1,
			partGoodReceiptDetailPageSize: 10,
			sortByPartGoodReceiptDetail: '',
			sortDescPartGoodReceiptDetail: '',
			sortingByPartGoodReceiptDetail: [],
			partGoodReceiptDetails: [],
			partGoodReceiptDetailId: '',
			totalPartGoodReceiptDetailRow: 0,
			isShowPartGoodReceiptDetailFilter: false,
			isDownloadPartGoodReceiptDetail: false,
			filterPartGoodReceiptCase: null,
			currentPartGoodReceiptCasePage: 1,
			partGoodReceiptCasePageSize: 10,
			sortByPartGoodReceiptCase: '',
			sortDescPartGoodReceiptCase: '',
			sortingByPartGoodReceiptCase: [],
			tempPartGoodReceiptCases: [],
			partGoodReceiptCases: [],
			partGoodReceiptCaseId: '',
			totalPartGoodReceiptCaseRow: 0,
			isShowPartGoodReceiptCaseFilter: false,
			isDownloadPartGoodReceiptCase: false,
			purchaseOrderDetails: [],
			parts: [],
			controlCards: [],
			partGoodReceiptDetails: [],
			purchaseOrders: [],
			purchaseOrders: [],
			isPurchaseOrderComboLoading: false,
			isShowPopupConfirmation: false,
			isDataCommited: false,
			mainRecordId: '',
			isPurchaseOrderComboLoading: false,
			isPartGoodReceiptComboLoading: false,
			isPurchaseOrderDetailComboLoading: false,
			isPartComboLoading: false,
			isControlCardComboLoading: false,
			isShowPopupPDF: false,
			pdfUrl: '',
			isLastGR: false,
			sumQtyCaseByPartId: [],
		}
	},
	methods: {
		checkLastGR(item) {
			if (this.isLastGR == true && item.controlCard != null && item.controlCard.qcStatusId != null) {
				this.isLastGR = false;
			}
			return this.isLastGR
		},
		getPartNumSpec(part) {
			if(part == null){
				 return '';
			} else if(part.partNumber && part.partSpecification) {
				return part.partNumber + ' - ' + part.partSpecification;
			} else if (part.partNumber && !part.partSpecification) {
				return part.partNumber;
			} else if(!part.partNumber && part.partSpecification) {
				return part.partSpecification;
			}
		},
		printMcc: async function (item) {
			this.isBusy = true;
			try {
				var result = await PartGoodReceiptCase.printMcc(this, item.id);
			}catch {
				this.isBusy = false;
			}
			this.isBusy = false;
		},
		printMccBatch: async function () {
			this.isBusy = true;
			try {
				var result = await PartGoodReceiptCase.printMccBatch(this, this.modelId);
			} catch {
				this.isBusy = false;
			}
			this.isBusy = false;
		},
		printPdf: async function () {
			if (this.partGoodReceiptDetails != null && this.partGoodReceiptDetails.some(item => item.isAlreadyQc == false)) {
				const msg = this.$createElement;
				const msgNode = msg('div', {
					domProps: {
						innerHTML: '<p>Masih ada Part yang belum di QC. Apakah anda yakin untuk mendownload Dokumen GR?</p>'
					}
				});
				this.$bvModal.msgBoxConfirm([msgNode], {
					title: 'Confirmation',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'danger',
					okTitle: 'Yes',
					cancelTitle: 'No',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				})
					.then(async value => {
						if (value) {
							try {
								this.isBusy = true;
								this.isShowPopupPDF = false;
								var result = await PartGoodReceipt.printGrPdf(this, this.modelId);
								this.isShowPopupPDF = true;
								this.pdfUrl = result.download;	
								this.isBusy = false;
							} catch {
								this.isBusy = false;
							}
						}
					})
					.catch(err => { })
			} else {
				try {
					this.isBusy = true;
					this.isShowPopupPDF = false;
					var result = await PartGoodReceipt.printGrPdf(this, this.modelId);
					this.isShowPopupPDF = true;
					this.pdfUrl = result.download;	
					this.isBusy = false;
				} catch {
					this.isBusy = false;
				}
			}
		},
		getPartGoodReceipt: async function (id) {
			this.isBusy = true;
			PartGoodReceipt.getData(this, id).then(async result => {
				this.model = result;
				this.mainRecordId = String(result.mainRecordId);
				let promises = Array();


				if (this.model.purchaseOrderId != null) {
					promises.push(
						await this.getPartGoodReceipts(this.model.purchaseOrderId),
						this.getPurchaseOrder(this.model.purchaseOrderId).then(result => {
							return true;
						}).catch(error => {
							this.$store.dispatch('addErrorMessageGlobal', error);
							throw error;
						})
					);
				}

				Promise.all(promises).then((results) => {
					this.isBusy = false;
				});
			}).catch(error => { this.isBusy = false; });
		},
		downloadData() {
			this.isDownloadPartGoodReceipt = true;
			this.filterPartGoodReceipt.id = this.modelId;
			PartGoodReceipt.downloadDataDetail(this, this.filterPartGoodReceipt).then(result => {
				this.isDownloadPartGoodReceipt = false;
			}).catch(error => { this.isDownloadPartGoodReceipt = false; })
		},
		getPartGoodReceiptDetails: async function (isAddRow) {
			let filter = {};
			Object.assign(filter, this.filterPartGoodReceiptDetail);
			if (this.modelId == null) return;
			filter.partGoodReceiptId = this.modelId;
			filter.draftMode = "0";
			if (this.sortByPartGoodReceiptDetail != null) {
				this.sortingByPartGoodReceiptDetail[this.sortByPartGoodReceiptDetail] = this.sortDescPartGoodReceiptDetail;
			}
			let currentPage = (this.currentPartGoodReceiptDetailPage - 1);
			if (isAddRow) {
				let totalData = this.totalPartGoodReceiptDetailRow + 1;
				let page = Math.ceil(totalData / this.partGoodReceiptDetailPageSize);
				currentPage = page - 1;
			}
			// disable paging start
			currentPage = null;
			this.partGoodReceiptDetailPageSize = 0;
			// disable paging end
			PartGoodReceiptDetail.getList(this, filter, this.sortingByPartGoodReceiptDetail, currentPage, this.partGoodReceiptDetailPageSize).then(result => {
				this.currentPartGoodReceiptDetailPage = currentPage + 1;
				this.partGoodReceiptDetails = result.data;
				this.totalPartGoodReceiptDetailRow = result.dataCount;
			}).catch(error => { });
		},
		getPartGoodReceiptCases: async function (isAddRow) {
			let filter = {};
			Object.assign(filter, this.filterPartGoodReceiptCase);
			if (this.modelId == null) return;
			filter.partGoodReceiptId = this.modelId;
			filter.draftMode = "0";
			if (this.sortByPartGoodReceiptCase != null) {
				this.sortingByPartGoodReceiptCase[this.sortByPartGoodReceiptCase] = this.sortDescPartGoodReceiptCase;
			}
			let currentPage = (this.currentPartGoodReceiptCasePage - 1);
			if (isAddRow) {
				let totalData = this.totalPartGoodReceiptCaseRow + 1;
				let page = Math.ceil(totalData / this.partGoodReceiptCasePageSize);
				currentPage = page - 1;
			}
			// disable paging start
			currentPage = null;
			this.partGoodReceiptCasePageSize = 0;
			// disable paging end
			this.tempPartGoodReceiptCases =[];
			PartGoodReceiptCase.getList(this, filter, this.sortingByPartGoodReceiptCase, currentPage, this.partGoodReceiptCasePageSize).then(result => {
				this.currentPartGoodReceiptCasePage = currentPage + 1;
				this.partGoodReceiptCases = result.data;
				this.totalPartGoodReceiptCaseRow = result.dataCount;

				this.partGoodReceiptCases.forEach(element => {
					let checkData = this.tempPartGoodReceiptCases.find(p=>p.id == element.id);
					if(checkData != null) return;
					let data = {"id": element.id, "qtyPo_": element.qtyPo};
					this.tempPartGoodReceiptCases.push(data);
					//this.collectQtyReceive.push({ key: element.partId + "|" + element.supplierCaseNumber, value: element.qtyReceive })
				});

				this.sumQtyCaseByPartId = result.data.reduce((acc, item) => {
					if(!acc[item.partId])
					{
						acc[item.partId] = 0;
					}
					acc[item.partId] += item.qtyPo;
					return acc;
				}, {})

			}).catch(error => { });
		},
		getPartGoodReceipts: async function (input) {
			let filter = new PartGoodReceiptFilter();
			if (input != undefined) {
				filter.purchaseOrderId = input;
			}
			this.isPartGoodReceiptComboLoading = true;
			filter.draftMode = "-1";
			PartGoodReceipt.getList(this, filter, null, 0, 10)
				.then(result => {
					if (result != null) {
						this.partGoodReceipts = result.data
						let lastItem = this.partGoodReceipts[0];
						if (lastItem.id == this.modelId) {
							this.isLastGR = true;
						} else {
							this.isLastGR = false;
						}
					}
					this.isPartGoodReceiptComboLoading = false;
				})
				.catch(error => { });
		},
		getParts: async function (input) {
			let filter = new PartFilter();
			if (input != undefined) {
				filter.partNumber = input;
			}
			this.isPartComboLoading = true;
			Part.getList(this, filter, null, 0, 10)
				.then(result => {
					if (result != null) {
						this.parts = result.data
					}
					this.isPartComboLoading = false;
				})
				.catch(error => { });
		},
		getControlCard: async function (id) {
			if (id == null || id == undefined || id == "") return;
			try {
				let data = ControlCard.getData(this, id);
				return data;
			}
			catch { };
		},
		getControlCards: async function (input) {
			let filter = new ControlCardFilter();
			if (input != undefined) {
				filter.controlCardNumber = input;
			}
			this.isControlCardComboLoading = true;
			ControlCard.getList(this, filter, null, 0, 10)
				.then(result => {
					if (result != null) {
						this.controlCards = result.data
					}
					this.isControlCardComboLoading = false;
				})
				.catch(error => { });
		},
		getPurchaseOrders: async function (input) {
			let filter = new PurchaseOrderFilter();
			if (input != undefined) {
				filter.purchaseOrderNumber = input;
			}
			filter.fwDocStat = '0,1';
			filter.exactType.fwDocStat = '1';
			PurchaseOrder.getList(this, filter, null, 0, 10)
				.then(result => {
					if (result != null) {
						this.purchaseOrders = result.data
					}
				})
				.catch(error => { });
		},
		setSelectedPurchaseOrderExecuted(item) {
			let _this = this;
			if (item == undefined || item == null) {
				this.model.purchaseOrderId = null;
				this.model.purchaseOrder = null;
				this.isBusy = true;
				PartGoodReceipt.resetDocument(this, this.model.id).then(result => {
					this.getPartGoodReceipt(this.model.id).then(result => {
						this.getPartGoodReceiptDetails();
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				}).catch(error => { this.isBusy = false; });
			} else {
				this.model.purchaseOrderId = item.id;
				this.model.purchaseOrder = item;

				this.isBusy = true;
				PartGoodReceipt.copyFromDocument(this, 'purchaseorder', item.id, this.model.id).then(result => {
					this.getPartGoodReceipt(this.model.id).then(result => {
						this.getPartGoodReceiptDetails();
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				}).catch(error => { this.isBusy = false; });
			}
		},
		setSelectedPurchaseOrder(item) {
			if (item) {
				var itemId = Number(item.id);
				if (this.model.purchaseOrderId == itemId) return;
			}

			if (this.partGoodReceiptDetails != null && this.partGoodReceiptDetails.length > 0) {
				const msg = this.$createElement;
				const msgNode = msg('div', {
					domProps: {
						innerHTML: '<p>Perubahan terhadap Part Good Receipt akan me-reset form yang sudah diinput sebelumnya.</p><p>Apakah anda yakin akan melanjutkan?</p>'
					}
				});
				this.$bvModal.msgBoxConfirm([msgNode], {
					title: 'Confirmation',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'danger',
					okTitle: 'Yes',
					cancelTitle: 'No',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				})
					.then(value => {
						if (value) {
							this.setSelectedPurchaseOrderExecuted(item);
						}
					})
					.catch(err => { })
			} else {
				this.setSelectedPurchaseOrderExecuted(item);
			}
		},
		getPurchaseOrder: async function (id) {
			PurchaseOrder.getData(this, id).then(result => {
				this.model.purchaseOrder = result;
				this.isBusy = false;
				return result;
			}).catch(error => { });
		},
		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		handleScroll() {
			this.$refs.partGoodReceiptInput.scrollTop = 0;
		},
		saveAction(modalEvent) {
			modalEvent.preventDefault();
			this.handleScroll();
			let id = this.$route.params.id;
			this.$v.model.$touch();
			if (this.$v.model.$anyError) {
				return;
			} else {
				this.isBusy = true;
				let id = this.modelId;
				let model = this.model;

				if (id != '' && id != null && id != undefined) {
					PartGoodReceipt.commitData(this, model, id).then(result => {
						this.isDataCommited = true;
						this.$router.push({ name: 'partgoodreceiptindex' });
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				} else {
					PartGoodReceipt.insertData(this, model).then(result => {
						this.isDataCommited = true;
						this.$router.push({ name: 'partgoodreceiptindex' });
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				}
			}
		},
		updateData() {
			let id = this.modelId;
			let model = this.model;
			let promises = Array();
			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					// PartGoodReceipt.updateDataDetail(this, model, id)
					// 	.catch((error) => {
					// 		this.getPartGoodReceipt(id);
					// 	});
				}
			});
		},
		onHidden() {
			this.getPartGoodReceipts();
		},
		addRowDataPartGoodReceiptDetail(modalEvent, model) {
			if (model != null) {
				if (model.id != null && model.id != '') {
					model.partGoodReceiptId = this.modelId;
					PartGoodReceiptDetail.updateDataDetail(this, model, model.id)
						.then(result => {
							this.getPartGoodReceiptDetails(true);
							this.isShowPopupPartGoodReceiptDetail = false;
						})
				} else {
					model.partGoodReceiptId = this.modelId;
					PartGoodReceiptDetail.createDataDetail(this, model)
						.then(result => {
							this.getPartGoodReceiptDetails(true);
							this.isShowPopupPartGoodReceiptDetail = false;
						})
				}
			}
		},
		async editRowDataPartGoodReceiptDetail(id) {
			this.partGoodReceiptDetailId = id;
			this.isShowPopupPartGoodReceiptDetail = true;
		},
		async deleteRowDataPartGoodReceiptDetail(id) {
			PartGoodReceiptDetail.deleteData(this, id).then(result => { this.getPartGoodReceiptDetails(); });
		},
		async resetDataPartGoodReceiptDetail() {
			this.partGoodReceiptDetailId = "";
			this.isShowPopupPartGoodReceiptDetail = true;
		},
		async addDataPartGoodReceiptDetail() {
			PartGoodReceiptDetail.createData(this, { partGoodReceiptId: this.modelId })
				.then(result => {
					this.getPartGoodReceiptDetails(true);
				})
		},
		async addFromClipboardPartGoodReceiptDetail() {
			let parts = new Array();
			navigator.clipboard.readText().then(value => {
				if (value.match(/(?:\r\n|\r|\n)/g)) { value = value.replace(/(?:\r\n|\r|\n)/g, ','); }
				let values = value.split(",");
				values.forEach(item => {
					parts.push({ part: item, partGoodReceiptId: this.modelId });
				});
				PartGoodReceiptDetail.addFromClipboard(this, parts).then(result => { this.getPartGoodReceiptDetails() });
			});
		},
		async replaceFromClipboardPartGoodReceiptDetail() {
			let parts = new Array();
			navigator.clipboard.readText().then(value => {
				if (value.match(/(?:\r\n|\r|\n)/g)) { value = value.replace(/(?:\r\n|\r|\n)/g, ','); }
				let values = value.split(",");
				values.forEach(item => {
					parts.push({ part: item, partGoodReceiptId: this.modelId });
				});
				PartGoodReceiptDetail.replaceFromClipboard(this, parts).then(result => { this.getPartGoodReceiptDetails() });
			});
		},
		showPopupUploadPartGoodReceiptDetail() {
			if (this.partGoodReceiptDetails != null && this.partGoodReceiptDetails.length > 0) {
				const msg = this.$createElement;
				const msgNode = msg('div', {
					domProps: {
						innerHTML: '<p>Perubahan terhadap PartGoodReceiptDetail akan me-reset data yang sudah diinput sebelumnya.</p><p>Apakah anda yakin akan melanjutkan?</p>'
					}
				});
				this.$bvModal.msgBoxConfirm([msgNode], {
					title: 'Confirmation',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'danger',
					okTitle: 'Yes',
					cancelTitle: 'No',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				})
					.then(value => {
						if (value) {
							this.isShowPopupUploadPartGoodReceiptDetail = true;
						}
					})
					.catch(err => { })
			} else {
				this.isShowPopupUploadPartGoodReceiptDetail = true;
			}
		},
		uploadDataPartGoodReceiptDetail(modalEvent, newDatas) {
			this.isShowPopupUploadPartGoodReceiptDetail = false;
		},
		downloadPartGoodReceiptDetail(modalEvent) {
			this.isDownloadPartGoodReceiptDetail = true;
			this.filterPartGoodReceiptDetail.partGoodReceiptId = this.modelId;
			PartGoodReceiptDetail.downloadDataDetail(this, this.filterPartGoodReceiptDetail).then(result => {
				this.isDownloadPartGoodReceiptDetail = false;
			}).catch(error => { this.isDownloadPartGoodReceiptDetail = false; })
		},
		saveInputPartGoodReceiptDetail(item) {
			if (this.partGoodReceipts != null && this.partGoodReceipts != undefined && this.partGoodReceipts.length > 0) {
				item.partGoodReceipt = this.partGoodReceipts.find(q => q.id == item.partGoodReceiptId);
			}
			if (this.parts != null && this.parts != undefined && this.parts.length > 0) {
				item.part = this.parts.find(q => q.id == item.partId);
			}


			let id = item.id;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					PartGoodReceiptDetail.updateDataDetail(this, item, item.id);
				}
			});
		},
		addRowDataPartGoodReceiptCase(modalEvent, model) {
			if (model != null) {
				if (model.id != null && model.id != '') {
					model.partGoodReceiptId = this.modelId;
					PartGoodReceiptCase.updateDataDetail(this, model, model.id)
						.then(result => {
							this.getPartGoodReceiptCases(true);
							this.isShowPopupPartGoodReceiptCase = false;
						})
				} else {
					model.partGoodReceiptId = this.modelId;
					PartGoodReceiptCase.createDataDetail(this, model)
						.then(result => {
							this.getPartGoodReceiptCases(true);
							this.isShowPopupPartGoodReceiptCase = false;
						})
				}
			}
		},
		async editRowDataPartGoodReceiptCase(id) {
			this.partGoodReceiptCaseId = id;
			this.isShowPopupPartGoodReceiptCase = true;
		},
		async deleteRowDataPartGoodReceiptCase(id) {
			PartGoodReceiptCase.deleteData(this, id).then(result => { this.getPartGoodReceiptCases(); });
		},
		async resetDataPartGoodReceiptCase() {
			this.partGoodReceiptCaseId = "";
			this.isShowPopupPartGoodReceiptCase = true;
		},
		async addDataPartGoodReceiptCase() {
			PartGoodReceiptCase.createData(this, { partGoodReceiptId: this.modelId })
				.then(result => {
					this.getPartGoodReceiptCases(true);
				})
		},
		async addFromClipboardPartGoodReceiptCase() {
			let parts = new Array();
			navigator.clipboard.readText().then(value => {
				if (value.match(/(?:\r\n|\r|\n)/g)) { value = value.replace(/(?:\r\n|\r|\n)/g, ','); }
				let values = value.split(",");
				values.forEach(item => {
					parts.push({ part: item, partGoodReceiptId: this.modelId });
				});
				PartGoodReceiptCase.addFromClipboard(this, parts).then(result => { this.getPartGoodReceiptCases() });
			});
		},
		async replaceFromClipboardPartGoodReceiptCase() {
			let parts = new Array();
			navigator.clipboard.readText().then(value => {
				if (value.match(/(?:\r\n|\r|\n)/g)) { value = value.replace(/(?:\r\n|\r|\n)/g, ','); }
				let values = value.split(",");
				values.forEach(item => {
					parts.push({ part: item, partGoodReceiptId: this.modelId });
				});
				PartGoodReceiptCase.replaceFromClipboard(this, parts).then(result => { this.getPartGoodReceiptCases() });
			});
		},
		showPopupUploadPartGoodReceiptCase() {
			if (this.partGoodReceiptCases != null && this.partGoodReceiptCases.length > 0) {
				const msg = this.$createElement;
				const msgNode = msg('div', {
					domProps: {
						innerHTML: '<p>Perubahan terhadap PartGoodReceiptCase akan me-reset data yang sudah diinput sebelumnya.</p><p>Apakah anda yakin akan melanjutkan?</p>'
					}
				});
				this.$bvModal.msgBoxConfirm([msgNode], {
					title: 'Confirmation',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'danger',
					okTitle: 'Yes',
					cancelTitle: 'No',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				})
					.then(value => {
						if (value) {
							this.isShowPopupUploadPartGoodReceiptCase = true;
						}
					})
					.catch(err => { })
			} else {
				this.isShowPopupUploadPartGoodReceiptCase = true;
			}
		},
		uploadDataPartGoodReceiptCase(modalEvent, newDatas) {
			this.isShowPopupUploadPartGoodReceiptCase = false;
		},
		downloadPartGoodReceiptCase(modalEvent) {
			this.isDownloadPartGoodReceiptCase = true;
			this.filterPartGoodReceiptCase.partGoodReceiptId = this.modelId;
			PartGoodReceiptCase.downloadDataDetail(this, this.filterPartGoodReceiptCase).then(result => {
				this.isDownloadPartGoodReceiptCase = false;
			}).catch(error => { this.isDownloadPartGoodReceiptCase = false; })
		},
		saveInputPartGoodReceiptCase(item) {
			if (this.controlCards != null && this.controlCards != undefined && this.controlCards.length > 0) {
				item.controlCard = this.controlCards.find(q => q.id == item.controlCardId);
			}
			if (this.partGoodReceiptDetails != null && this.partGoodReceiptDetails != undefined && this.partGoodReceiptDetails.length > 0) {
				item.partGoodReceiptDetail = this.partGoodReceiptDetails.find(q => q.id == item.partGoodReceiptDetailId);
			}
			let tempPartCase = null;
			let qtyTotal = 0;
			if(this.tempPartGoodReceiptCases != null && this.tempPartGoodReceiptCases != undefined && this.tempPartGoodReceiptCases.length > 0)
			{
				tempPartCase = this.tempPartGoodReceiptCases.find(q => q.id == item.id);
				qtyTotal = this.sumQtyCaseByPartId[item.partId];
			}
			let id = item.id;
			let promises = Array();
			var valuePo = 0;
			if (item.qtyPo.toString().includes(',')) {
				let value = parseFloat(item.qtyPo.toString().replace(",", "."));
				valuePo += value;
			} else {
				let value = parseFloat(item.qtyPo.toString());
				valuePo += value;
			}
			this.partGoodReceiptCases.forEach(el => {
				if(el.partId == item.partId && item.id != el.id) {
					if (el.qtyPo.toString().includes(',')) {
						let value = parseFloat(el.qtyPo.toString().replace(",", "."));
						valuePo += value;
					} else {
						let value = parseFloat(el.qtyPo.toString());
						valuePo += value;
					}
				}
			});
			var valuePos = 0;
			if (this.totalPartGoodReceiptCaseRow == 1) {
				valuePos = parseFloat(item.partGoodReceiptDetail.qtyOutstandingBefore.toString());
				qtyTotal = valuePos;
			} else {
				valuePos = parseFloat(item.purchaseOrderDetail.qtyOutstanding.toString());
				qtyTotal += valuePos;
			}
			console.log("total", qtyTotal);
			if (item.qtyPo != tempPartCase.qtyPo_ && valuePo > qtyTotal) {
				const msg = this.$createElement;
				let msgNode = '';
				msgNode = msg('div', { domProps: { innerHTML: '<p>Qty PO melebihi sisa Qty Outstanding, apakah anda ingin melanjutkan?</p>' } })
				this.$bvModal.msgBoxConfirm([msgNode], {
					title: 'Alert',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'secondary',
					okTitle: 'Yes',
					cancelTitle: 'No',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				}).then(e => {
					if (e) {
						Promise.all(promises).then((results) => {
							if (id != '' && id != null && id != undefined) {
								PartGoodReceiptCase.recalculateQtyPo(this, item.id, item).then(response => {
									this.getPartGoodReceiptCases();

								});
							}
						});
					}
				});
			} else {
				Promise.all(promises).then((results) => {
					if (id != '' && id != null && id != undefined) {
						PartGoodReceiptCase.recalculateQtyPo(this, item.id, item).then(response => {
							this.getPartGoodReceiptCases();
						});
					}
				});

			}

		},
		resetModal(modalType) {
			this.isShowPopupUploadPartGoodReceiptDetail = false;
			this.isShowPopupPartGoodReceiptDetail = false;
			this.isShowPopupPDF = false;
			if (modalType == 'PartGoodReceiptDetail') {
				this.getPartGoodReceiptDetails();
			}
			this.isShowPopupUploadPartGoodReceiptCase = false;
			this.isShowPopupPartGoodReceiptCase = false;
			if (modalType == 'PartGoodReceiptCase') {
				this.getPartGoodReceiptCases();
			}
			this.showPopupCopyData = false;
			this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768) {
				//this.isShowPartGoodReceiptDetailFilter = true;
				//this.isShowPartGoodReceiptCaseFilter = true;
			}
		},
	},
	beforeMount() {
		this.filterPartGoodReceipt = new PartGoodReceiptFilter();
		this.filterPartGoodReceiptDetail = new PartGoodReceiptDetailFilter();
		this.filterPartGoodReceiptCase = new PartGoodReceiptCaseFilter();
		//this.getPartGoodReceipts();
		//this.getPurchaseOrderDetails();
		//this.getParts();
		//this.getControlCards();
		//this.getPartGoodReceiptDetails();
		//this.getPurchaseOrders();
	},
	async mounted() {
		let id = this.$route.params.id;
		let copyData = this.$route.params.copydata;
		if (id != '' && id != null && id != undefined) {
			if (copyData != null && copyData != undefined) {
				this.getPartGoodReceipt(id);
			} else {
				this.modelId = id;
				this.getPartGoodReceipt(id);
			}
		}
		this.$nextTick(() => {
			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
		});
	},
	computed: {
		isAllowSaveDraft: {
			get: function () {
				if (this.model.mainRecordId != undefined || this.model.mainRecordId != null) return false;
				return true;
			}
		}
	},
	watch: {
		sortByPartGoodReceiptDetail: {
			handler: function () {
				this.getPartGoodReceiptDetails();
			}
		},
		sortDescPartGoodReceiptDetail: {
			handler: function () {
				this.getPartGoodReceiptDetails();
			}
		},
		currentPartGoodReceiptDetailPage: {
			handler: function () {
				this.getPartGoodReceiptDetails();
			}
		},
		partGoodReceiptDetailPageSize: {
			handler: function () {
				this.getPartGoodReceiptDetails();
			}
		},
		filterPartGoodReceiptDetail: {
			handler: function () {
				this.getPartGoodReceiptDetails();
			},
			deep: true,
		},
		sortByPartGoodReceiptCase: {
			handler: function () {
				this.getPartGoodReceiptCases();
			}
		},
		sortDescPartGoodReceiptCase: {
			handler: function () {
				this.getPartGoodReceiptCases();
			}
		},
		currentPartGoodReceiptCasePage: {
			handler: function () {
				this.getPartGoodReceiptCases();
			}
		},
		partGoodReceiptCasePageSize: {
			handler: function () {
				this.getPartGoodReceiptCases();
			}
		},
		filterPartGoodReceiptCase: {
			handler: function () {
				this.getPartGoodReceiptCases();
			},
			deep: true,
		},
	},
}
</script>
